<template>
  <div class="container has-text-left">
    <b-table
        v-if="tableData.length > 0"
        :narrowed="true"
        :striped="true"
        :data="tableData"
    >
      <template slot-scope="props">
        <b-table-column field="num" class="is-hidden-mobile" numeric>{{props.row.num}}</b-table-column>
        <b-table-column field="automationName" label="Automation">
          <router-link :to="{path: '/configure/automations/' + props.row.automationId}">
            {{props.row.automationName}}
          </router-link>
        </b-table-column>
        <b-table-column field="runId" label="Run ID" class="is-hidden-mobile">{{props.row.runId}}</b-table-column>
        <b-table-column field="timestamp" label="Time" centered>{{props.row.localTime}}</b-table-column>
        <b-table-column field="hftResult" label="Result" class="is-hidden-mobile" centered>{{props.row.hftResult}}
        </b-table-column>
      </template>
    </b-table>
    <div v-else>No log data, yet.</div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import {formatTime} from '../../utils/utils.js';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    name: "automation-log",
    components: {
      BTableColumn,
      BTable
    },
    props: ['id'],
    data() {
      return {
        timestampStart: 0,
        entries: []
      }
    },
    computed: {
      ...mapGetters('log', ['automationLogTimestampStart', 'automationLogById']),
      tableData() {
        const ret = [];

        let num = 0;
        this.entries.forEach(item => {
          num++;

          const hftResult = parseInt(item.status, 10) !== 0 ? item.result : 'OK';

          ret.push({
            ...item,
            localTime: formatTime(item['timestamp']),
            automationId: item['automation_id'],
            automationName: item['automation_name'],
            runId: item['run_id'],
            hftResult: hftResult,
            num
          });
        });

        return ret;
      }
    },
    methods: {
      ...mapActions('log', ['fetchAutomationsLog']),
    },
    mounted() {
      this.timestampStart = Math.floor(new Date().getTime() / 1000) - this.automationLogTimestampStart;
      this.fetchAutomationsLog({
        timestampStart: this.timestampStart,
        automationId: this.id,
        onSuccess: () => {
          this.entries = this.automationLogById(this.id);
        }
      });
    }
  }
</script>

<style scoped>

</style>